// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const ENTER_TO_GROUP = "Vstup do skupiny";
export const GROUP_ASKED_TO_JOIN = "Po\u017eiadala si o \u010dlenstvo";
export const GROUP_ASK_TO_JOIN = "Po\u017eiadaj o \u010dlenstvo";
export const GROUP_counter_ACTIVE_MEMBERS = ["%(counter)s akt\u00edvny \u010dlen", "%(counter)s akt\u00edvni \u010dlenovia", "%(counter)s akt\u00edvnych \u010dlenov"];
export const JOIN_GROUP = "Pridaj sa ku skupine";
export const NEW_FEMININE = "Nov\u00e1";
